import React, { createContext, useContext } from 'react';
import { usePersistedState } from '../hooks/usePersistedState';
import { AUTH_INITIAL_STATE, LOCAL_STORAGE_AUTH_KEY } from '../constants';

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
    const [state, setState] = usePersistedState(AUTH_INITIAL_STATE, LOCAL_STORAGE_AUTH_KEY);

    return <AuthContext.Provider value={{ state, setState }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const authContext = useContext(AuthContext);
    if (!authContext) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }
    return authContext;
};



// WEBPACK FOOTER //
// ./src/contexts/AuthContext.js